// @flow
import { defineMessages } from 'react-intl';

// ENG-30200 AC#1 -- the "Add A Household Member" member-type chooser that
// sits in front of the Add Adult/Minor Mini-Profile (MiniProfileBridge).
export default defineMessages({
  title: {
    id: 'app.containers.ResidentProfile.AddHouseholdMemberModal.title',
    defaultMessage: 'Add A Household Member',
  },
  instruction: {
    id: 'app.containers.ResidentProfile.AddHouseholdMemberModal.instruction',
    defaultMessage: 'Select your Household Member Type',
  },
  memberTypeLabel: {
    id: 'app.containers.ResidentProfile.AddHouseholdMemberModal.memberTypeLabel',
    defaultMessage: 'Member Type',
  },
  // Design mock (DESIGN-ENG-30200.md) shows this literal text ("Adult") as
  // the placeholder-gray, unselected state of the dropdown -- not a real
  // selection. See the judgment-call comment in index.js next to its usage.
  memberTypePlaceholder: {
    id: 'app.containers.ResidentProfile.AddHouseholdMemberModal.memberTypePlaceholder',
    defaultMessage: 'Adult',
  },
  memberTypeRequired: {
    id: 'app.containers.ResidentProfile.AddHouseholdMemberModal.memberTypeRequired',
    defaultMessage: 'Required',
  },
  adultOption: {
    id: 'app.containers.ResidentProfile.AddHouseholdMemberModal.adultOption',
    defaultMessage: 'Adult',
  },
  minorOption: {
    id: 'app.containers.ResidentProfile.AddHouseholdMemberModal.minorOption',
    defaultMessage: 'Minor',
  },
  cancel: {
    id: 'app.containers.ResidentProfile.AddHouseholdMemberModal.cancel',
    defaultMessage: 'Cancel',
  },
  continue: {
    id: 'app.containers.ResidentProfile.AddHouseholdMemberModal.continue',
    defaultMessage: 'Continue',
  },
});
